import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { verifyUnsubscribeToken, submitUnsubscribeFeedback } from '../../../data/reducers/emailPreferencesReducer';
import './EmailPreferences.css';

const UnsubscribeFeedback = () => {
  const { token } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { tokenValid, isVerifying, isSubmitting, error } = useSelector(state => state.emailPreferences);

  const [feedbackReason, setFeedbackReason] = useState('');
  const [additionalComments, setAdditionalComments] = useState('');

  useEffect(() => {
    if (token) {
      dispatch(verifyUnsubscribeToken(token));
    }
  }, [dispatch, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(submitUnsubscribeFeedback(token, {
      reason_category: feedbackReason || null,
      reason_text: additionalComments || null,
    }));

    // Route to EmailPreferences and signal via location state that the user has just
    // unsubscribed. We cannot rely on the Redux `success` string because EmailPreferences
    // dispatches verifyUnsubscribeToken on mount, which overwrites `success` before the
    // includes('unsubscribed') check can fire — leaving the user on the form screen.
    if (result) {
      history.push(`/email-preferences/${token}`, { unsubscribed: true });
    }
  };

  if (token && (isVerifying || tokenValid === null)) {
    return (
      <div className="email-preferences-scope unsubscribe-feedback-page-container">

        <div className="unsubscribe-feedback-main-card">
          <div style={{textAlign: 'center', padding: '40px'}}>
            <div className="loading-spinner"></div>
            Verifying your request...
          </div>
        </div>
      </div>
    );
  }

  if (tokenValid === false && !isVerifying) {
    return (
      <div className="email-preferences-scope unsubscribe-feedback-page-container">

        <div className="unsubscribe-feedback-main-card">
          <div style={{textAlign: 'center'}}>
            <div className="error-icon">😞</div>
            <h2>Oops, looks like this link is invalid</h2>
            <p>{error || 'This link is invalid or has expired.'}</p>
            <div className="unsubscribe-feedback-actions">
              <button
                className="unsubscribe-feedback-submit-btn"
                onClick={() => window.location.href = '/'}
              >
                Go to Homepage
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="email-preferences-scope unsubscribe-feedback-page-container">


      <div className="unsubscribe-feedback-main-card">
        <h2 className="unsubscribe-feedback-main-title">We're sad to see you go!</h2>

        {error && (
          <div style={{backgroundColor: '#ffebee', border: '1px solid #f44336', borderRadius: '4px', padding: '10px', marginBottom: '20px', color: '#d32f2f', fontSize: '14px'}}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="unsubscribe-feedback-row">
            <div className="unsubscribe-feedback-text-section">
              <label className="unsubscribe-feedback-field-label">
                Before you go, let us know how we can improve! (Optional)
              </label>
              <p className="unsubscribe-feedback-field-subtitle">
                Your feedback helps us improve your experience.
              </p>
            </div>
            <div className="unsubscribe-feedback-input-section">
              <select
                className="unsubscribe-feedback-dropdown"
                value={feedbackReason}
                onChange={(e) => setFeedbackReason(e.target.value)}
              >
                <option value="">Select a reason...</option>
                <option value="too-many-emails">Too many emails!</option>
                <option value="not-useful">I no longer find the notifications useful</option>
                <option value="certain-properties">I only want notifications for certain properties</option>
                <option value="other">Other (please specify)</option>
              </select>
            </div>
          </div>

          <div className="unsubscribe-feedback-row">
            <div className="unsubscribe-feedback-text-section">
              <label className="unsubscribe-feedback-field-label">
                Please share your reason (optional).
              </label>
              <p className="unsubscribe-feedback-field-subtitle reason-option">
                We'd love to hear your thoughts!
              </p>
            </div>
            <div className="unsubscribe-feedback-input-section">
              <input
                type="text"
                className="unsubscribe-feedback-input-field"
                value={additionalComments}
                onChange={(e) => setAdditionalComments(e.target.value)}
                placeholder="Tell us more about your experience..."
              />
            </div>
          </div>

          <div className="unsubscribe-feedback-actions">
            <button
              type="submit"
              className="unsubscribe-feedback-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Processing...' : 'Unsubscribe'}
            </button>
          </div>
        </form>
      </div>

      <div className="unsubscribe-feedback-page-footer">
        2025 Violerts. All rights reserved.
      </div>
    </div>
  );
};

export default UnsubscribeFeedback;